import { Component, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
    selector: 'demo-upp-select',
    templateUrl: './demo-upp-select.html',
    styleUrls: ['../demo-common.scss', './demo-upp-select.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppSelectComponent implements OnInit {
    form!: FormGroup;
    paymentMethod: string | null = null;
    isDisabled = false;

    countries = [
        { value: 'es', label: 'Spain' },
        { value: 'fr', label: 'France' },
        { value: 'de', label: 'Germany' },
        { value: 'it', label: 'Italy' },
        { value: 'pt', label: 'Portugal' },
        { value: 'gb', label: 'United Kingdom' },
    ];

    paymentMethods = [
        { value: 'cash', label: 'Cash' },
        { value: 'card', label: 'Card' },
        { value: 'transfer', label: 'Transfer' },
    ];

    constructor(private change: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.form = new FormGroup({
            country: new FormControl('es'),
        });
    }

    get selectedCountryLabel(): string {
        const code = this.form.get('country')?.value;
        return this.countries.find(c => c.value === code)?.label || 'None';
    }

    get selectedPaymentLabel(): string {
        return this.paymentMethods.find(p => p.value === this.paymentMethod)?.label || 'None';
    }

    toggleDisabled() {
        this.isDisabled = !this.isDisabled;
        const country = this.form?.get('country');
        if (country) {
            if (this.isDisabled) {
                country.disable({ emitEvent: false });
            } else {
                country.enable({ emitEvent: false });
            }
        }
        this.change.markForCheck();
    }

    onPaymentChanged(value: any) {
        this.paymentMethod = value;
        this.change.markForCheck();
    }
}
